// react
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// components
import { ClientReferralSentPage } from '@karehero/llama/pwa/pages/ClientReferralSentPage/ClientReferralSentPage';

// store
import { resetClientReferral } from 'store/slices/clientReferralSlice';

// router
import { ROUTES } from 'router';

/**
 * ClientReferralSent wires the ClientReferralSentPage to navigation
 */
export const ClientReferralSent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { firstName, lastName, email } = location.state || {};

  return (
    <ClientReferralSentPage
      firstName={firstName || ''}
      lastName={lastName || ''}
      email={email || ''}
      onInviteAnother={() => {
        dispatch(resetClientReferral());
        navigate(ROUTES.PORTAL_CLIENT_REFERRAL, { replace: true });
      }}
      onDone={() => navigate(ROUTES.PORTAL, { state: { back: true } })}
    />
  );
};

export default ClientReferralSent;
